export enum MyContainersTableIdEnum {
    allTablesContainers,
    step3DeviceTableContainers,
    step4AccessoriesTableContainers,
    step4WarrantiesTableContainers,
    step4ServicesContainers,
    step4UpgradesContainers,
    step5TableContainers,
}
